module.exports = __webpack_public_path__ + "media/images/videos/wedding_message-94b4b94870b9ca553773ded9bf7379a5.mp4";